import { useEffect, useState } from "react";
import { resolveImg } from "@/lib/api";
import { Box } from "lucide-react";

// Load model-viewer script once
let mvLoaded = false;
function loadModelViewer() {
  if (mvLoaded || typeof window === "undefined") return Promise.resolve();
  return new Promise((res) => {
    const s = document.createElement("script");
    s.type = "module";
    s.src = "https://ajax.googleapis.com/ajax/libs/model-viewer/3.5.0/model-viewer.min.js";
    s.onload = () => { mvLoaded = true; res(); };
    s.onerror = () => res();
    document.head.appendChild(s);
  });
}

export default function Model3DViewer({ src, poster }) {
  const [ready, setReady] = useState(false);
  const [failed, setFailed] = useState(false);
  useEffect(() => { loadModelViewer().then(() => setReady(true)); }, []);
  if (!src) return null;
  return (
    <div className="relative bg-[color:var(--forest-2)] aspect-square corner-frame overflow-hidden">
      {!ready && (
        <div className="absolute inset-0 flex flex-col items-center justify-center text-gold gap-2">
          <Box className="animate-pulse" size={26} />
          <span className="font-caption text-[10px]">Summoning artefact…</span>
        </div>
      )}
      {ready && !failed && (
        <model-viewer
          src={resolveImg(src)}
          poster={poster ? resolveImg(poster) : undefined}
          camera-controls
          auto-rotate
          shadow-intensity="1"
          exposure="0.95"
          environment-image="neutral"
          style={{ width: "100%", height: "100%", background: "transparent", "--poster-color": "#0F1D15" }}
          onError={() => setFailed(true)}
        />
      )}
      {failed && (
        <div className="absolute inset-0 flex items-center justify-center text-parchment/70 font-caption text-xs p-4 text-center">
          3D model unavailable — please view photographs.
        </div>
      )}
      <div className="absolute bottom-3 left-1/2 -translate-x-1/2 text-gold font-caption text-[10px] bg-[rgba(9,18,13,0.7)] px-3 py-1 border border-brass/40">
        Drag to rotate · Pinch to zoom
      </div>
    </div>
  );
}
